enum CouponTimeFilterEnum {
  Today = 0,
  Future = 1,
}

export default CouponTimeFilterEnum;
